/** Skeleton shown while the five category searches are in flight. */
export default function LifestyleLoader() {
  return (
    <div className="flex flex-col w-full max-w-[1392px] mx-auto px-4 py-6 gap-6" aria-busy="true" aria-live="polite">
      <span className="sr-only">Loading prizes</span>

      <div className="w-full h-[220px] lg:h-[320px] bg-gray-6 rounded-lg animate-pulse-fade" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-4">
        {Array.from({ length: 8 }).map((_, index) => (
          <div
            key={index}
            className="w-full h-[289px] bg-gray-6 rounded-lg animate-pulse-fade"
            style={{ animationDelay: `${index * 80}ms` }}
          />
        ))}
      </div>
    </div>
  );
}
